"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateSponsoredCompetitionBodyToJSON = exports.CreateSponsoredCompetitionBodyFromJSONTyped = exports.CreateSponsoredCompetitionBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function CreateSponsoredCompetitionBodyFromJSON(json) {
    return CreateSponsoredCompetitionBodyFromJSONTyped(json, false);
}
exports.CreateSponsoredCompetitionBodyFromJSON = CreateSponsoredCompetitionBodyFromJSON;
function CreateSponsoredCompetitionBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sponsorBrandName': json['sponsorBrandName'],
        'description': json['description'],
        'promotionImage': json['promotionImage'],
        'rewards': (json['rewards'].map(_1.CreateSponsoredRewardRequestFromJSON)),
        'runningMonth': json['runningMonth'],
        'runningYear': json['runningYear'],
        'email': !(0, runtime_1.exists)(json, 'email') ? undefined : (0, _1.SponsoredRewardEmailFromJSON)(json['email']),
        'brandUrl': json['brandUrl'],
    };
}
exports.CreateSponsoredCompetitionBodyFromJSONTyped = CreateSponsoredCompetitionBodyFromJSONTyped;
function CreateSponsoredCompetitionBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sponsorBrandName': value.sponsorBrandName,
        'description': value.description,
        'promotionImage': value.promotionImage,
        'rewards': (value.rewards.map(_1.CreateSponsoredRewardRequestToJSON)),
        'runningMonth': value.runningMonth,
        'runningYear': value.runningYear,
        'email': (0, _1.SponsoredRewardEmailToJSON)(value.email),
        'brandUrl': value.brandUrl,
    };
}
exports.CreateSponsoredCompetitionBodyToJSON = CreateSponsoredCompetitionBodyToJSON;
